/**
 * Product identity (named Lensky on 2026-09-28; domain lensky.org). Change it
 * here and in index.html <title>, public/favicon.svg, capacitor.config.ts.
 */
export const BRAND = {
  name: 'Lensky',
  shortName: 'Lensky',
  tagline: 'Read music and keep the beat, a few minutes a day.',
} as const;
